import ErrorFormatService from '../../services/error-format-service';
import {
  GET_DEAL_DATA_SUCCESS, SAVE_DEAL_DATA, SAVE_DEAL_DATA_SUCCESS, SAVE_DEAL_DATA_ERROR, SAVE_DEAL_STATUS_SUCCESS,
  GET_DEAL_PARTICIPANT_LIST_DATA_SUCCESS, SAVE_DEAL_PARTICIPANT_SUCCESS, DELETE_DEAL_PARTICIPANT_LIST_SUCCESS,
  SAVE_DEAL_TASK_SUCCESS, DELETE_DEAL_TASK_LIST_SUCCESS, SAVE_DEAL_FILE_SUCCESS, DELETE_DEAL_FILE_LIST_SUCCESS,
  DELETE_DEAL_TERM_SUCCESS, SAVE_DEAL_VALUATION_FILE_SUCCESS, DELETE_DEAL_VALUATION_FILE_SUCCESS, RESET_FORM_ERRORS,
  SAVE_DEAL_TASK_STATUS_SUCCESS, DELETE_DEAL_TASK_COMMENT_SUCCESS, SAVE_ACTIVITY_STATUS_LIST_SUCCESS,
  DELETE_ACTIVITY_LIST_SUCCESS, SAVE_ACTIVITY_STATUS_SUCCESS, DELETE_ACTIVITY_COMMENT_SUCCESS,
  SAVE_DEAL_TASK_COMMENT_SUCCESS, GET_ACTIVITY_LIST_DATA_SUCCESS, SAVE_ACTIVITY_LIST_DATA_SUCCESS,
  DELETE_DEAL_TERM_GROUP_SUCCESS, DELETE_DEAL_TASK_GROUP_SUCCESS, DELETE_DEAL_FILE_GROUP_SUCCESS,
  GET_DEAL_TASK_LIST_DATA_SUCCESS, GET_DEAL_FILE_LIST_DATA_SUCCESS, SAVE_DEAL_TASK_LIST_SUCCESS,
  SAVE_DEAL_TAB_SETTINGS_SUCCESS, SAVE_ACTIVITY_COMMENT_SUCCESS, SAVE_DEAL_SCHEDULE_SUCCESS,
  DELETE_DEAL_SCHEDULE_SUCCESS, GET_LIST_CONTACT_PERSON_DATA_SUCCESS, GET_LIST_CONTACT_COMPANY_DATA_SUCCESS,
  GET_LIST_DEAL_ASSET_DATA_SUCCESS, GET_LIST_CONTACT_PERSON_INTERNAL_DATA_SUCCESS,
  GET_LIST_DEAL_TASK_CONTACT_PERSON_DATA_SUCCESS, SAVE_DEAL_FILE_GROUP_ORDER_SETTINGS_SUCCESS,
  SAVE_DEAL_TASK_GROUP_ORDER_SETTINGS_SUCCESS, SAVE_DEAL_TERM_GROUP_ORDER_SETTINGS_SUCCESS,
  GET_LIST_CONTACT_NOT_PARTICIPANT_DATA_SUCCESS, SAVE_DEAL_PARTICIPANT_LIST_SUCCESS,
  DELETE_DEAL_PARTICIPANT_COMMENT_SUCCESS, SAVE_DEAL_PARTICIPANT_COMMENT_SUCCESS,
  SAVE_DEAL_TASK_REVIEW_STATUS_SUCCESS, SAVE_DEAL_TASK_TEMPLATE_DATA_SUCCESS, LOAD_DEAL_TASK_TEMPLATE_DATA_SUCCESS,
  SAVE_DEAL_PARTICIPANT_ERROR, SAVE_DEAL_TASK_ERROR, SAVE_DEAL_FILE_ERROR, SAVE_DEAL_VALUATION_FILE_ERROR,
  SAVE_ACTIVITY_LIST_DATA, SAVE_ACTIVITY_LIST_DATA_ERROR, SAVE_DEAL_TASK, SAVE_DEAL_PARTICIPANT, SAVE_DEAL_FILE,
  SAVE_DEAL_VALUATION_FILE, RESET_DEAL_DATA, RESET_NEW_DEAL_ID, LOGIN_USER_SUCCESS, RESET_DEAL_FILE_CHAT_RESPONSE_TEXT,
  LOGOUT_USER_SUCCESS, GET_LIST_TAG_DATA_SUCCESS, GET_DEAL_DATA_BY_FILE_SUCCESS, RESET_DEAL_FILE_ANALYZED,
  GET_DEAL_TASK_ATTACHMENT_TEXT_DATA, GET_DEAL_TASK_ATTACHMENT_TEXT_DATA_SUCCESS,
  GET_DEAL_TASK_ATTACHMENT_TEXT_DATA_ERROR, GET_DEAL_FILE_TEXT_DATA, GET_DEAL_FILE_TEXT_DATA_SUCCESS,
  GET_DEAL_FILE_TEXT_DATA_ERROR,
} from '../../constants/system/actions';

const dealReducer: Reducer = (
  state: ReducerState = {
    dealData: null,
    newDealId: null,
    formErrors: {},
    isFormSaving: false,
    isDealFileAnalyzed: false,
    isDealFileChatResponseLoading: false,
    dealFileChatResponseText: null,
  },
  action: ReduxAction,
): ReducerState => {
  switch (action.type) {
    case GET_DEAL_DATA_SUCCESS:
      return {
        ...state,
        dealData: action.data,
      };
    case GET_DEAL_DATA_BY_FILE_SUCCESS:
      return {
        ...state,
        isDealFileAnalyzed: true,
        dealData: {
          ...state.dealData,
          dealCommonData: {
            ...state.dealData.dealCommonData,
            name: state.dealData.dealCommonData.name || action.data.dealCommonData.name || null,
            asset: {
              ...state.dealData.dealCommonData.asset,
              name: state.dealData.dealCommonData.asset.name || action.data.dealCommonData.asset.name || null,
              address: state.dealData.dealCommonData.asset.address || action.data.dealCommonData.asset.address || null,
              streetAddress: state.dealData.dealCommonData.asset.address
                ? state.dealData.dealCommonData.asset.streetAddress || null
                : (action.data.dealCommonData.asset.address && action.data.dealCommonData.asset.streetAddress) || null,
              city: state.dealData.dealCommonData.asset.address ? state.dealData.dealCommonData.asset.city || null
                : (action.data.dealCommonData.asset.address && action.data.dealCommonData.asset.city) || null,
              state: state.dealData.dealCommonData.asset.address ? state.dealData.dealCommonData.asset.state || null
                : (action.data.dealCommonData.asset.address && action.data.dealCommonData.asset.state) || null,
              postalCode: state.dealData.dealCommonData.asset.address
                ? state.dealData.dealCommonData.asset.postalCode || null
                : (action.data.dealCommonData.asset.address && action.data.dealCommonData.asset.postalCode) || null,
              lotSize: state.dealData.dealCommonData.asset.lotSize || action.data.dealCommonData.asset.lotSize || null,
              types: state.dealData.dealCommonData.asset.types || action.data.dealCommonData.asset.types || null,
            },
            amount: state.dealData.dealCommonData.amount || action.data.dealCommonData.amount || null,
            loanAmount: state.dealData.dealCommonData.loanAmount || action.data.dealCommonData.loanAmount || null,
            loanType: state.dealData.dealCommonData.loanType || action.data.dealCommonData.loanType || null,
            zfaAmount: state.dealData.dealCommonData.zfaAmount || action.data.dealCommonData.zfaAmount || null,
            gsfAmount: state.dealData.dealCommonData.gsfAmount || action.data.dealCommonData.gsfAmount || null,
            nsfAmount: state.dealData.dealCommonData.nsfAmount || action.data.dealCommonData.nsfAmount || null,
            unitsAmount: state.dealData.dealCommonData.unitsAmount || action.data.dealCommonData.unitsAmount || null,
            keysAmount: state.dealData.dealCommonData.keysAmount || action.data.dealCommonData.keysAmount || null,
            acresAmount: state.dealData.dealCommonData.acresAmount || action.data.dealCommonData.acresAmount || null,
            lotsfAmount: state.dealData.dealCommonData.lotsfAmount || action.data.dealCommonData.lotsfAmount || null,
            description: state.dealData.dealCommonData.description || action.data.dealCommonData.description || null,
            type: state.dealData.dealCommonData.type || action.data.dealCommonData.type || null,
            askingPrice: state.dealData.dealCommonData.askingPrice || action.data.dealCommonData.askingPrice || null,
            equityRequired: state.dealData.dealCommonData.equityRequired
              || action.data.dealCommonData.equityRequired || null,
            estimatedTdc: state.dealData.dealCommonData.estimatedTdc || action.data.dealCommonData.estimatedTdc || null,
          },
        },
      };
    case GET_DEAL_TASK_ATTACHMENT_TEXT_DATA:
      return {
        ...state,
        isDealFileChatResponseLoading: true,
      };
    case GET_DEAL_TASK_ATTACHMENT_TEXT_DATA_SUCCESS:
      return {
        ...state,
        isDealFileChatResponseLoading: false,
        dealFileChatResponseText: action.data.text,
      };
    case GET_DEAL_TASK_ATTACHMENT_TEXT_DATA_ERROR:
      return {
        ...state,
        isDealFileChatResponseLoading: false,
      };
    case GET_DEAL_FILE_TEXT_DATA:
      return {
        ...state,
        isDealFileChatResponseLoading: true,
      };
    case GET_DEAL_FILE_TEXT_DATA_SUCCESS:
      return {
        ...state,
        isDealFileChatResponseLoading: false,
        dealFileChatResponseText: action.data.text,
      };
    case GET_DEAL_FILE_TEXT_DATA_ERROR:
      return {
        ...state,
        isDealFileChatResponseLoading: false,
      };
    case SAVE_DEAL_DATA:
      return {
        ...state,
        formErrors: {},
        isFormSaving: true,
      };
    case SAVE_DEAL_DATA_SUCCESS:
      return {
        ...state,
        newDealId: action.data.newDealId,
        formErrors: {},
        isFormSaving: false,
      };
    case SAVE_DEAL_DATA_ERROR:
      if (!action.error) {
        return {
          ...state,
          isFormSaving: false,
        };
      }

      return {
        ...state,
        formErrors: ErrorFormatService.isFormError(action.error)
          ? ErrorFormatService.formatGraphQLErrors({ ...action.error })
          : ErrorFormatService.formatGraphQLMainError({ ...action.error }),
        isFormSaving: false,
      };
    case SAVE_DEAL_STATUS_SUCCESS:
      return {
        ...state,
        dealData: {
          ...state.dealData,
          dealCommonData: {
            ...state.dealData.dealCommonData,
            status: action.data.status,
            statusText: action.data.statusText,
            rejectReason: action.data.rejectReason,
            rejectReasonComment: action.data.rejectReasonComment,
          },
        },
      };
    case SAVE_DEAL_TAB_SETTINGS_SUCCESS:
      return {
        ...state,
        dealData: {
          ...state.dealData,
          tabSettings: action.data.tabSettings,
        },
      };
    case SAVE_DEAL_SCHEDULE_SUCCESS:
    case DELETE_DEAL_SCHEDULE_SUCCESS:
      return {
        ...state,
        dealData: {
          ...state.dealData,
          dealSchedulesData: action.data.dealSchedulesData,
        },
      };
    case GET_DEAL_PARTICIPANT_LIST_DATA_SUCCESS:
      return {
        ...state,
        dealData: {
          ...state.dealData,
          dealParticipantsData: action.data,
        },
      };
    case SAVE_DEAL_PARTICIPANT_SUCCESS:
      return {
        ...state,
        dealData: {
          ...state.dealData,
          dealParticipantsData: action.data.dealParticipantsData,
          dealParticipantsTotal: action.data.dealParticipantsTotal,
          dealParticipantGroupList: action.data.dealParticipantGroupList
            || (state.dealData && state.dealData.dealParticipantGroupList),
          contactNotParticipantList: action.data.contactNotParticipantList || state.dealData.contactNotParticipantList,
        },
        formErrors: {},
        isFormSaving: false,
      };
    case SAVE_DEAL_PARTICIPANT_LIST_SUCCESS:
    case DELETE_DEAL_PARTICIPANT_LIST_SUCCESS:
      return {
        ...state,
        dealData: {
          ...state.dealData,
          dealParticipantsData: action.data.dealParticipantsData,
          dealParticipantsTotal: action.data.dealParticipantsTotal,
          dealParticipantGroupList: action.data.dealParticipantGroupList
            || (state.dealData && state.dealData.dealParticipantGroupList),
          contactNotParticipantList: action.data.contactNotParticipantList || state.dealData.contactNotParticipantList,
        },
      };
    case SAVE_DEAL_TASK_SUCCESS:
      return {
        ...state,
        dealData: {
          ...state.dealData,
          dealTasksData: action.data.dealTasksData,
          dealTasksTotal: action.data.dealTasksTotal,
          dealTaskGroupList: action.data.dealTaskGroupList || (state.dealData && state.dealData.dealTaskGroupList),
          dealTaskPlainList: action.data.dealTaskPlainList || (state.dealData && state.dealData.dealTaskPlainList),
          dealTaskListFilters: action.data.dealTaskListFilters
            || (state.dealData && state.dealData.dealTaskListFilters),
        },
        formErrors: {},
        isFormSaving: false,
      };
    case DELETE_DEAL_TASK_LIST_SUCCESS:
    case DELETE_DEAL_TASK_GROUP_SUCCESS:
    case SAVE_DEAL_TASK_STATUS_SUCCESS:
    case SAVE_DEAL_TASK_REVIEW_STATUS_SUCCESS:
    case SAVE_DEAL_TASK_TEMPLATE_DATA_SUCCESS:
    case LOAD_DEAL_TASK_TEMPLATE_DATA_SUCCESS:
    case SAVE_DEAL_TASK_LIST_SUCCESS:
      return {
        ...state,
        dealData: {
          ...state.dealData,
          dealTasksData: action.data.dealTasksData,
          dealTasksTotal: action.data.dealTasksTotal,
          dealTaskGroupList: action.data.dealTaskGroupList || (state.dealData && state.dealData.dealTaskGroupList),
          dealTaskPlainList: action.data.dealTaskPlainList || (state.dealData && state.dealData.dealTaskPlainList),
          dealTaskListFilters: action.data.dealTaskListFilters
            || (state.dealData && state.dealData.dealTaskListFilters),
        },
      };
    case SAVE_DEAL_FILE_SUCCESS:
      return {
        ...state,
        dealData: {
          ...state.dealData,
          dealFilesData: action.data.dealFilesData,
          dealFilesTotal: action.data.dealFilesTotal,
          dealFileGroupList: action.data.dealFileGroupList || (state.dealData && state.dealData.dealFileGroupList),
        },
        formErrors: {},
        isFormSaving: false,
      };
    case DELETE_DEAL_FILE_LIST_SUCCESS:
    case DELETE_DEAL_FILE_GROUP_SUCCESS:
      return {
        ...state,
        dealData: {
          ...state.dealData,
          dealFilesData: action.data.dealFilesData,
          dealFilesTotal: action.data.dealFilesTotal,
          dealFileGroupList: action.data.dealFileGroupList || (state.dealData && state.dealData.dealFileGroupList),
        },
      };
    case DELETE_DEAL_TERM_SUCCESS:
    case DELETE_DEAL_TERM_GROUP_SUCCESS:
      return {
        ...state,
        dealData: {
          ...state.dealData,
          dealTermsData: action.data.dealTermsData,
        },
      };
    case SAVE_DEAL_VALUATION_FILE_SUCCESS:
      return {
        ...state,
        dealData: {
          ...state.dealData,
          dealValuationFilesData: action.data.dealValuationFilesData,
        },
        formErrors: {},
        isFormSaving: false,
      };
    case DELETE_DEAL_VALUATION_FILE_SUCCESS:
      return {
        ...state,
        dealData: {
          ...state.dealData,
          dealValuationFilesData: action.data.dealValuationFilesData,
        },
      };
    case SAVE_DEAL_TASK:
    case SAVE_DEAL_PARTICIPANT:
    case SAVE_DEAL_FILE:
    case SAVE_DEAL_VALUATION_FILE:
    case SAVE_ACTIVITY_LIST_DATA:
      return {
        ...state,
        formErrors: {},
        isFormSaving: true,
      };
    case SAVE_DEAL_TASK_ERROR:
    case SAVE_DEAL_PARTICIPANT_ERROR:
    case SAVE_DEAL_FILE_ERROR:
    case SAVE_DEAL_VALUATION_FILE_ERROR:
    case SAVE_ACTIVITY_LIST_DATA_ERROR:
      if (!action.error) {
        return {
          ...state,
          isFormSaving: false,
        };
      }

      return {
        ...state,
        formErrors: ErrorFormatService.isFormError(action.error)
          ? ErrorFormatService.formatGraphQLErrors({ ...action.error })
          : ErrorFormatService.formatGraphQLMainError({ ...action.error }),
        isFormSaving: false,
      };
    case DELETE_DEAL_TASK_COMMENT_SUCCESS:
    case SAVE_DEAL_TASK_COMMENT_SUCCESS:
      return {
        ...state,
        dealData: state.dealData ? {
          ...state.dealData,
          dealTasksData: state.dealData.dealTasksData.map((dealTaskGroupItem: DealTaskGroup): DealTaskGroup => ({
            ...dealTaskGroupItem,
            tasks: dealTaskGroupItem.tasks ? dealTaskGroupItem.tasks.map((dealTaskItem: DealTask): DealTask => ({
              ...dealTaskItem,
              comments: dealTaskItem.id === action.data.dealTaskId ? action.data.comments : dealTaskItem.comments,
              attachments: dealTaskItem.id === action.data.dealTaskId
                ? action.data.attachments : dealTaskItem.attachments,
              subTasks: dealTaskItem.subTasks ? dealTaskItem.subTasks.map((dealSubTaskItem: DealTask): DealTask => ({
                ...dealSubTaskItem,
                comments: dealSubTaskItem.id === action.data.dealTaskId
                  ? action.data.comments : dealSubTaskItem.comments,
                attachments: dealSubTaskItem.id === action.data.dealTaskId
                  ? action.data.attachments : dealSubTaskItem.attachments,
              })) : [],
            })) : [],
          })),
        } : null,
      };
    case DELETE_DEAL_PARTICIPANT_COMMENT_SUCCESS:
    case SAVE_DEAL_PARTICIPANT_COMMENT_SUCCESS:
      return {
        ...state,
        dealData: state.dealData ? {
          ...state.dealData,
          dealParticipantsData: state.dealData.dealParticipantsData.map((
            dealParticipantItem: DealParticipant,
          ): DealParticipant => ({
            ...dealParticipantItem,
            comments: dealParticipantItem.id === action.data.dealParticipantId
              ? action.data.comments : dealParticipantItem.comments,
            attachments: dealParticipantItem.id === action.data.dealParticipantId
              ? action.data.attachments : dealParticipantItem.attachments,
          })),
          dealCommentsData: action.data.isDealParticipant ? action.data.comments : state.dealCommentsData,
        } : null,
      };
    case GET_ACTIVITY_LIST_DATA_SUCCESS:
      if (action.data.dealId) {
        return {
          ...state,
          dealData: {
            ...state.dealData,
            dealActivityList: action.data.activityList,
            dealActivityTotal: action.data.activityTotal,
            dealActivityListSummaryData: action.data.activityListSummaryData,
            dealActivityFilters: action.data.activityListFilters,
          },
        };
      }

      return state;
    case SAVE_ACTIVITY_LIST_DATA_SUCCESS:
    case DELETE_ACTIVITY_LIST_SUCCESS:
    case SAVE_ACTIVITY_STATUS_SUCCESS:
    case SAVE_ACTIVITY_STATUS_LIST_SUCCESS:
      if (action.data.activityListData && action.data.activityListData.dealId) {
        return {
          ...state,
          dealData: {
            ...state.dealData,
            dealActivityList: action.data.activityListData && action.data.activityListData.activityList,
            dealActivityTotal: action.data.activityListData && action.data.activityListData.activityTotal,
            dealActivityListSummaryData: action.data.activityListData
              && action.data.activityListData.activityListSummaryData,
            dealActivityFilters: action.data.activityListData && action.data.activityListData.activityListFilters,
            contactCompanyList: action.data.activityListData && action.data.activityListData.contactCompanyList
              ? action.data.activityListData.contactCompanyList : state.dealData.contactCompanyList,
            contactPersonList: action.data.activityListData && action.data.activityListData.contactPersonList
              ? action.data.activityListData.contactPersonList : state.dealData.contactPersonList,
          },
          formErrors: {},
          isFormSaving: false,
        };
      }

      return state;
    case DELETE_ACTIVITY_COMMENT_SUCCESS:
    case SAVE_ACTIVITY_COMMENT_SUCCESS:
      return {
        ...state,
        dealData: state.dealData ? {
          ...state.dealData,
          dealActivityList: state.dealData.dealActivityList
            ? state.dealData.dealActivityList.map((activityItem: Activity): Activity => (
              activityItem.id === action.data.activityId && action.data.updatedData ? ({
                ...activityItem,
                updatedDate: action.data.updatedData.updatedDate,
                updatedDateText: action.data.updatedData.updatedDateText,
                updatedByUserText: action.data.updatedData.updatedByUserText,
                comments: action.data.comments,
                attachments: action.data.attachments,
              }) : activityItem
            )) : null,
        } : null,
      };
    case GET_DEAL_TASK_LIST_DATA_SUCCESS:
      return {
        ...state,
        dealData: {
          ...state.dealData,
          dealTasksData: action.payload && action.payload.page ? [...((
            state.dealData && state.dealData.dealTasksData
            && state.dealData.dealTasksData.map((dealTaskGroupItem: DealTaskGroup): DealTaskGroup => {
              const newDealTaskGroup: DealTaskGroup = action.data.dealTasksData
                .find((newDealTaskGroupItem: DealTaskGroup): boolean => (
                  newDealTaskGroupItem.id === dealTaskGroupItem.id
                ));

              if (newDealTaskGroup) {
                return {
                  ...dealTaskGroupItem,
                  tasks: [
                    ...dealTaskGroupItem.tasks,
                    ...newDealTaskGroup.tasks.filter((newDealTaskItem: DealTask): boolean => (
                      !dealTaskGroupItem.tasks.find((dealTaskItem: DealTask): boolean => (
                        newDealTaskItem.id === dealTaskItem.id
                      ))
                    )),
                  ],
                };
              }

              return dealTaskGroupItem;
            })
          ) || []), ...(
            state.dealData && state.dealData.dealTasksData
              ? action.data.dealTasksData.filter((newDealTaskGroupItem: DealTaskGroup): boolean => (
                !state.dealData.dealTasksData.find((dealTaskGroupItem: DealTaskGroup): boolean => (
                  newDealTaskGroupItem.id === dealTaskGroupItem.id
                ))
              )) : action.data.dealTasksData
          )] : action.data.dealTasksData,
          dealTasksTotal: (action.payload && action.payload.page) || (!action.data.dealTasksTotal
            && action.data.dealTasksTotal !== 0) ? (state.dealData && state.dealData.dealTasksTotal)
            : action.data.dealTasksTotal,
          dealTaskGroupList: (action.payload && action.payload.page) || !action.data.dealTaskGroupList
            ? (state.dealData && state.dealData.dealTaskGroupList) : action.data.dealTaskGroupList,
          dealTaskPlainList: (action.payload && action.payload.page) || !action.data.dealTaskPlainList
            ? (state.dealData && state.dealData.dealTaskPlainList) : action.data.dealTaskPlainList,
          dealTaskListFilters: (action.payload && action.payload.page) || !action.data.dealTaskListFilters
            ? (state.dealData && state.dealData.dealTaskListFilters) : action.data.dealTaskListFilters,
        },
      };
    case GET_DEAL_FILE_LIST_DATA_SUCCESS:
      return {
        ...state,
        dealData: {
          ...state.dealData,
          dealFilesData: [...((
            state.dealData && state.dealData.dealFilesData
            && state.dealData.dealFilesData.map((dealFileGroupItem: DealFileGroup): DealFileGroup => {
              const newDealFileGroup: DealFileGroup = action.data
                .find((newDealFileGroupItem: DealFileGroup): boolean => (
                  newDealFileGroupItem.id === dealFileGroupItem.id
                ));

              if (newDealFileGroup) {
                return {
                  ...dealFileGroupItem,
                  files: [
                    ...dealFileGroupItem.files,
                    ...newDealFileGroup.files.filter((newDealFileItem: DealFile): boolean => (
                      !dealFileGroupItem.files.find((dealFileItem: DealFile): boolean => (
                        newDealFileItem.id === dealFileItem.id
                      ))
                    )),
                  ],
                };
              }

              return dealFileGroupItem;
            })
          ) || []), ...(
            state.dealData && state.dealData.dealFilesData
              ? action.data.filter((newDealFileGroupItem: DealFileGroup): boolean => (
                !state.dealData.dealFilesData.find((dealFileGroupItem: DealFileGroup): boolean => (
                  newDealFileGroupItem.id === dealFileGroupItem.id
                ))
              )) : action.data
          )],
        },
      };
    case GET_LIST_CONTACT_PERSON_DATA_SUCCESS:
      if (!state.dealData) {
        return state;
      }

      return {
        ...state,
        dealData: {
          ...state.dealData,
          contactPersonList: action.data,
        },
      };
    case GET_LIST_CONTACT_COMPANY_DATA_SUCCESS:
      if (!state.dealData) {
        return state;
      }

      return {
        ...state,
        dealData: {
          ...state.dealData,
          contactCompanyList: action.data,
        },
      };
    case GET_LIST_CONTACT_PERSON_INTERNAL_DATA_SUCCESS:
      if (!state.dealData) {
        return state;
      }

      return {
        ...state,
        dealData: {
          ...state.dealData,
          contactPersonInternalList: action.data,
        },
      };
    case GET_LIST_CONTACT_NOT_PARTICIPANT_DATA_SUCCESS:
      if (!state.dealData) {
        return state;
      }

      return {
        ...state,
        dealData: {
          ...state.dealData,
          contactNotParticipantList: action.data,
        },
      };
    case GET_LIST_DEAL_TASK_CONTACT_PERSON_DATA_SUCCESS:
      if (!state.dealData) {
        return state;
      }

      return {
        ...state,
        dealData: {
          ...state.dealData,
          dealTaskContactPersonList: action.data,
        },
      };
    case GET_LIST_DEAL_ASSET_DATA_SUCCESS:
      if (!state.dealData) {
        return state;
      }

      return {
        ...state,
        dealData: {
          ...state.dealData,
          assetList: action.data,
        },
      };
    case GET_LIST_TAG_DATA_SUCCESS:
      if (!state.dealData) {
        return state;
      }

      return {
        ...state,
        dealData: {
          ...state.dealData,
          tagList: action.data,
        },
      };
    case SAVE_DEAL_TERM_GROUP_ORDER_SETTINGS_SUCCESS:
      if (!action.payload || !action.payload.dealTermGroupIds) {
        return state;
      }

      return {
        ...state,
        dealData: {
          ...state.dealData,
          dealTermsData: action.payload.dealTermGroupIds
            .map((dealTermGroupId: number, dealTermGroupIdIndex: number): DealTermGroup => ({
              ...state.dealData.dealTermsData.find((dealTermGroupItem: DealTermGroup): boolean => (
                dealTermGroupItem.id === dealTermGroupId
              )),
              order: dealTermGroupIdIndex + 1,
            })),
        },
      };
    case SAVE_DEAL_TASK_GROUP_ORDER_SETTINGS_SUCCESS:
      if (!action.payload || !action.payload.dealTaskGroupIds) {
        return state;
      }

      return {
        ...state,
        dealData: {
          ...state.dealData,
          dealTasksData: action.payload.dealTaskGroupIds
            .map((dealTaskGroupId: number, dealTaskGroupIdIndex: number): DealTaskGroup => ({
              ...state.dealData.dealTasksData.find((dealTaskGroupItem: DealTaskGroup): boolean => (
                dealTaskGroupItem.id === dealTaskGroupId
              )),
              order: dealTaskGroupIdIndex + 1,
            })),
        },
      };
    case SAVE_DEAL_FILE_GROUP_ORDER_SETTINGS_SUCCESS:
      if (!action.payload || !action.payload.dealFileGroupIds) {
        return state;
      }

      return {
        ...state,
        dealData: {
          ...state.dealData,
          dealFilesData: action.payload.dealFileGroupIds
            .map((dealFileGroupId: number, dealFileGroupIdIndex: number): DealFileGroup => ({
              ...state.dealData.dealFilesData.find((dealFileGroupItem: DealFileGroup): boolean => (
                dealFileGroupItem.id === dealFileGroupId
              )),
              order: dealFileGroupIdIndex + 1,
            })),
        },
      };
    case RESET_DEAL_DATA:
      return {
        ...state,
        dealData: null,
        formErrors: {},
        isFormSaving: false,
        isDealFileAnalyzed: false,
        isDealFileChatResponseLoading: false,
        dealFileChatResponseText: null,
      };
    case RESET_NEW_DEAL_ID:
      return {
        ...state,
        newDealId: null,
      };
    case RESET_FORM_ERRORS:
      return {
        ...state,
        formErrors: {},
      };
    case RESET_DEAL_FILE_ANALYZED:
      return {
        ...state,
        isDealFileAnalyzed: false,
      };
    case RESET_DEAL_FILE_CHAT_RESPONSE_TEXT:
      return {
        ...state,
        dealFileChatResponseText: null,
      };
    case LOGIN_USER_SUCCESS:
    case LOGOUT_USER_SUCCESS:
      return {
        ...state,
        dealData: null,
        newDealId: null,
        formErrors: {},
        isFormSaving: false,
        isDealFileAnalyzed: false,
        isDealFileChatResponseLoading: false,
        dealFileChatResponseText: null,
      };
    default:
      return state;
  }
};

export default dealReducer;
